module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodsnow-642273f8206ec54e6fe4b2f074aab536.svg";